(function () {
  // ❌ No mostrar en checkout
  if (window.location.pathname.includes("/checkout")) {
    let bar = document.getElementById("contador-urgencia");
    if (bar) bar.style.display = "none";
    return;
  }

  const DURACION = 10 * 60; // 10 minutos
  const STORAGE_KEY = "contador_urgencia_expiracion";

  let ahora = Math.floor(Date.now() / 1000);
  let expiracion = localStorage.getItem(STORAGE_KEY);

  if (!expiracion || ahora >= expiracion) {
    expiracion = ahora + DURACION;
    localStorage.setItem(STORAGE_KEY, expiracion);
  }

  function actualizarContador() {
    let ahora = Math.floor(Date.now() / 1000);
    let restante = expiracion - ahora;

    if (restante <= 0) {
      expiracion = ahora + DURACION;
      localStorage.setItem(STORAGE_KEY, expiracion);
      restante = DURACION;
    }

    let minutos = Math.floor(restante / 60);
    let segundos = restante % 60;
    if (segundos < 10) segundos = "0" + segundos;

    let el = document.getElementById("tiempo");
    if (!el) return;

    let nuevoValor = minutos + ":" + segundos;

    if (el.innerText !== nuevoValor) {
      el.style.opacity = "0";
      el.style.transform = "translateY(-4px)";

      setTimeout(function () {
        el.innerText = nuevoValor;
        el.style.opacity = "1";
        el.style.transform = "translateY(0)";
      }, 150);
    }
  }

  setInterval(actualizarContador, 1000);
  actualizarContador();

  // Sombra suave al hacer scroll
  window.addEventListener("scroll", function () {
    let bar = document.getElementById("contador-urgencia");
    if (!bar) return;

    window.scrollY > 5
      ? bar.classList.add("scrolled")
      : bar.classList.remove("scrolled");
  });
})();
